import Vue from "vue";
import Router from "vue-router";

Vue.use(Router)

export default new Router({
    routes: [
        {
            path:'/',
            redirect: '/login'
        },
        {
            path: '/',
            component: resolve => require(['../components/nav/framework.vue'], resolve),
            children: [
                {
                    path: '/account_overview',
                    component: resolve => require(['../components/pages/AccountOverview.vue'], resolve),
                },
                {
                    path: '/vendor_overview',
                    component: resolve => require(['../components/pages/VendorOverview.vue'], resolve),
                },
                {
                    path: '/vendor_show',
                    component: resolve => require(['../components/pages/VendorShow.vue'], resolve),
                },
                {
                    path: '/account_setting',
                    component: resolve => require(['../components/pages/AccountSetting.vue'], resolve),
                },
                {
                    path: '/doctor_overview',
                    component: resolve => require(['../components/pages/DoctorOverview.vue'], resolve),
                },
                {
                    path: '/patient_overview',
                    component: resolve => require(['../components/pages/PatientOverview.vue'], resolve),
                },
                {
                    path: '/patient_show',
                    component: resolve => require(['../components/pages/PatientShow.vue'], resolve),
                },
                {
                    path: '/question_overview',
                    component: resolve => require(['../components/pages/QuestionOverview.vue'], resolve),
                },
                {
                    path: '/question_overview_son',
                    component: resolve => require(['../components/pages/QuestionOverviewSon.vue'], resolve),
                },
                {
                    path: '/statistics',
                    component: resolve => require(['../components/pages/Statistics.vue'], resolve),
                },
                {
                    path: '/cross_analysis',
                    component: resolve => require(['../components/pages/CrossAnalysis.vue'], resolve),
                },
                {
                    path: '/question_content',
                    component: resolve => require(['../components/pages/QuestionContent.vue'], resolve),
                },
                {
                    path: '/create_question',
                    component: resolve => require(['../components/pages/CreateQuestion.vue'], resolve),
                },
                {
                    path: '/question_statistics',
                    component: resolve => require(['../components/pages/QuestionStatistics.vue'], resolve),
                },
                {
                    path: '/son_question_analysis',
                    component: resolve => require(['../components/pages/SonQuestionAnalysis.vue'], resolve),
                },
                {
                    path: '/question_analysis',
                    component: resolve => require(['../components/pages/QuestionAnalysis.vue'], resolve),
                },
                {
                    path: '/question_assign',
                    component: resolve => require(['../components/pages/QuestionAssign.vue'], resolve),
                },
                {
                    path: '/question_ans',
                    component: resolve => require(['../components/pages/QuestionAns.vue'], resolve),
                },
                {
                    path: '/question_chart',
                    component: resolve => require(['../components/pages/QuestionChart.vue'], resolve),
                },
                {
                    path: '/question_edit',
                    component: resolve => require(['../components/pages/QuestionEdit.vue'], resolve),
                },

                {
                    path: '/single_chat',
                    component: resolve => require(['../components/pages/single_chat.vue'], resolve),
                },
                {
                    path: '/push_message',
                    component: resolve => require(['../components/pages/push_message.vue'], resolve),
                },
                {
                    path: '/chat_bot',
                    component: resolve => require(['../components/pages/ChatBot.vue'], resolve),
                },
                {
                    path: '/line_point_setting',
                    component: resolve => require(['../components/pages/LinePointSetting.vue'], resolve),
                },
                {
                    path: '/line_point_deposit',
                    component: resolve => require(['../components/pages/LinePointDeposit.vue'], resolve),
                },
                {
                    path: '/line_point_check',
                    component: resolve => require(['../components/pages/LinePointCheck.vue'], resolve),
                },
                {
                    path: '/line_point_view',
                    component: resolve => require(['../components/pages/LinePointView.vue'], resolve),
                },
            ]
        },
        {
            path: '/login',
            component: resolve => require(['../components/pages/Login.vue'], resolve),
        },
    ]
})
